module.exports = __webpack_public_path__ + "img/progress-3.b171fedf.png";